import React from 'react';
import { Mail, Phone, MapPin, Instagram, Linkedin, Facebook, Twitter } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="bg-brand-purple text-white pt-24 pb-12 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-20">
          {/* Brand Col */}
          <div className="space-y-6">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-brand-lime rounded-lg flex items-center justify-center">
                <span className="text-brand-purple font-bold text-xl">K</span>
              </div>
              <span className="text-2xl font-display font-bold">KHALIL <span className="text-brand-lime"> & CO</span></span>
            </div>
            <p className="text-white/60 leading-relaxed max-w-xs">
              L'agence digitale qui propulse votre vision. Design premium, stratégie locale, impact global. Basée à Dakar.
            </p>
            <div className="flex gap-4">
                {[
                  {
                    icon: Linkedin,
                    href: "https://www.linkedin.com"
                  },
                  {
                    icon: Instagram,
                    href: "https://www.instagram.com"
                  },
                  {
                    icon: Facebook,
                    href: "https://www.facebook.com"
                  },
                  {
                    icon: Twitter,
                    href: "https://twitter.com"
                  }
                ].map((social, i) => (
                  <a
                    key={i}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-brand-lime hover:text-brand-purple transition-all duration-300"
                  >
                    <social.icon className="w-5 h-5" />
                  </a>
                ))}
              </div>
          </div>
          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-brand-lime">Navigation</h4>
            <ul className="space-y-4">
              {['Accueil', 'Services', 'À propos', 'Portfolio', 'Contact'].map((item) => (
                <li key={item}>
                  <a href={`#${item.toLowerCase().replace(' ', '-')}`} className="text-white/60 hover:text-white hover:translate-x-1 transition-all inline-block">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-brand-lime">Expertises</h4>
            <ul className="space-y-4">
              {['Social Media', 'Web Design', 'Branding', 'Ads Marketing', 'E-commerce'].map((item) => (
                <li key={item}>
                  <a href="#services" className="text-white/60 hover:text-white transition-colors">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          {/* Contact Info */}
          <div className="space-y-6">
            <h4 className="text-lg font-bold mb-6 text-brand-lime">Contact</h4>
            <div className="space-y-4 text-white/60">
              <a href="mailto:khalilcosenegal@gmail.com" className="flex items-center gap-3 hover:text-white transition-colors">
                <Mail className="w-5 h-5 text-brand-lime" />
                khalilcosenegal@gmail.com
              </a>
              <a href="tel:+221782412211" className="flex items-center gap-3 hover:text-white transition-colors">
                <Phone className="w-5 h-5 text-brand-lime" />
                +221 78 241 22 11
              </a>
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-brand-lime mt-1 flex-shrink-0" />
                <span>335, Cite Port,<br />Dakar, Sénégal</span>
              </div>
            </div>
          </div>
        </div>
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="text-white/30 text-sm">
            © {currentYear} KHALIL & CO. Tous droits réservés.
          </div>
          <div className="flex gap-8 text-xs text-white/40">
            <a href="#" className="hover:text-brand-lime transition-colors">Politique de confidentialité</a>
            <a href="#" className="hover:text-brand-lime transition-colors">Mentions Légales</a>
            <a href="#" className="hover:text-brand-lime transition-colors">CGU</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
